import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import InstagramEmbed from "@/components/InstagramEmbed";
import { INSTAGRAM } from "@/lib/social";

// Mídias reais — posts do Instagram da LC Production
const REEL = { id: "Dbb8I80RBeC", type: "reel", tag: "LC Production", label: "Assista" };

const POSTS = [
    { id: "DcMZEA5RqD2", tag: "LC Cerimonial", label: "Cerimônia" },
    { id: "DbrUg18GvQv", tag: "AstroLive", label: "A pista virou show" },
    { id: "Db9p89glZS_", tag: "LC Cerimonial", label: "Cerimônia" },
    { id: "DbmHAQBGiwu", tag: "AstroLive", label: "Ao vivo" },
    { id: "DccKqTORMRB", tag: "LC Cerimonial", label: "Momento especial" },
    { id: "Da6dkKOg9CC", tag: "AstroLive", label: "Performance" },
    { id: "DZGlVZYmvtb", tag: "AstroLive", label: "Energia de pista" },
];

const TileLabel = ({ tag, label }) => (
    <div className="flex items-baseline justify-between mb-3">
        <p className="text-[10px] tracking-[0.35em] uppercase text-[#6A2022] font-bold">{tag}</p>
        <p className="text-[10px] tracking-[0.2em] uppercase text-[#0A0A0A]/40">{label}</p>
    </div>
);

const Portfolio = () => (
    <section data-testid="portfolio-section" className="bg-white px-6 md:px-12 py-28 md:py-40 border-t border-black/10">
        <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
                <div>
                    <Reveal>
                        <p className="text-[10px] tracking-[0.45em] uppercase text-[#6A2022] mb-8" data-testid="portfolio-label">
                            Portfólio
                        </p>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[1.05] tracking-tight" data-testid="portfolio-headline">
                            Isso não se explica.{" "}
                            <span className="font-editorial italic font-light normal-case text-[#6A2022]">
                                Se vive.
                            </span>
                        </h2>
                    </Reveal>
                </div>
                <Reveal delay={0.2}>
                    <a
                        href={INSTAGRAM.cerimonial}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="portfolio-instagram-link"
                        className="inline-flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase text-[#0A0A0A]/50 hover:text-[#6A2022] transition-colors duration-300"
                    >
                        Conteúdo real — direto do Instagram
                        <ArrowUpRight className="w-4 h-4" />
                    </a>
                </Reveal>
            </div>

            <div className="grid md:grid-cols-3 gap-8 md:gap-10">
                <Reveal className="md:row-span-2">
                    <div className="h-full flex flex-col" data-testid="portfolio-item-reel">
                        <TileLabel tag={REEL.tag} label={REEL.label} />
                        <div className="flex-1 border border-black/10 overflow-hidden min-h-[560px] md:min-h-0">
                            <InstagramEmbed id={REEL.id} type={REEL.type} title="Vídeo LC Production" />
                        </div>
                    </div>
                </Reveal>
                {POSTS.map((post, i) => (
                    <Reveal key={post.id} delay={(i % 3) * 0.08}>
                        <div data-testid={`portfolio-item-${post.id}`}>
                            <TileLabel tag={post.tag} label={post.label} />
                            <div className="border border-black/10 overflow-hidden h-[520px]">
                                <InstagramEmbed id={post.id} title={`${post.tag} — ${post.label}`} />
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Portfolio;
